export default __webpack_public_path__ + "static/media/convert.2810f71b.svg";